export default __webpack_public_path__ + "static/media/photo3.f5beeb06.jpg";